import "./ag-grid-setup.js";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "shared/redux/store";
import { BrowserRouter } from "react-router-dom";
import { Core } from "./Core";
import "shared/assets/styles/_base.scss";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);

  root.render(
    <Provider store={store}>
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <Core />
      </BrowserRouter>
    </Provider>,
  );
} else {
  console.error("Root element not found!");
}
